// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"fa4442fc","228":"12dafcf9","412":"c4d34137","716":"fa4442fc","778":"81a1e90e"}[chunkId] + ".chunk.css";
};